import React from 'react'
import Edit from '../crud/edit'
import fields from './fields'
import menuItems from './menuItems'

const EditInstitutionUser = props => {
  return (
    <Edit
// @ts-ignore
      title='Edit Institution User'
      fields={fields}
      apiPath={`admin/institution_users/${props.params.institutionUserId}`}
      successRedirectPath='/membership/institution-users'
      buildMenuItems={menuItems}
    />
  )
}

export default EditInstitutionUser
